import { addGlobalMessage } from "@api/global_messages"
import { RATE_LIMIT_MESSAGE, isRateLimited } from "@src/helpers/rate_limit"

export const notifyIfRateLimited = dispatch => error => {
  if (isRateLimited(error)) {
    dispatch(addGlobalMessage(RATE_LIMIT_MESSAGE, "error"))
  }
}
